import React from "react";
import { txtA } from "../../../Label/Lbl";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import { useInvAF, useInvMain } from "../../../St/Reviews/UseStyle";
import Paper from "@material-ui/core/Paper";
import ButtonBase from "@material-ui/core/ButtonBase";

const UnderHeadreCar = (props) => {

    const { found, inv, sta, locInv } = props;
    const clasm = useInvMain();
    const clas = useInvAF();
    // const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};
    return (
        <Grid
            item
            container
            style={{ fontWeight: "bold", fontFamily: "Amiri-Regular", marginLeft: "0cm", marginRight: "0rem", paddingTop: "0.5rem" }}
        >
            <Grid item xs={12}>
                <Grid item container >
                    {locInv.ProcTypeInvProc != "03" && locInv.ProcTypeInvProc != "04" ?
                        (
                            <Grid item xs={3} container>
                                <Grid item xs={3}></Grid>
                                {
                                    inv.tax > 0 && (
                                        <Grid item xs={8}>
                                            <ButtonBase style={{ border: "solid 1px" }}>
                                                <img
                                                    src={`data:image/jpeg;base64,${inv.qr_image}`}
                                                    style={{ height: 100, width: 100 }}
                                                />
                                            </ButtonBase>
                                        </Grid>
                                    )
                                }
                                <Grid item xs={1}></Grid>
                            </Grid>
                        )
                        :
                        (<Grid item xs={2} container>
                            <Grid item xs={12}></Grid>
                        </Grid>)
                    }
                    <Grid item xs={9} container>
                        {locInv.ProcTypeInvProc != "03" && (
                            <Grid item xs={12} container>
                                <Grid item xs={11} container className={clas.BdytitleHedMusa}>
                                    <Grid item xs={6} className={clasm.minclr}>
                                        {sta.tot.tax_no_cust === ""
                                            ? "فاتورة ضريبية مبسطة"
                                            : "فاتورة ضريبية"}
                                    </Grid>
                                    <Grid item xs={6} className={clasm.minclr}>
                                        {sta.tot.tax_no_cust === ""
                                            ? "Simplified Tax Invoice"
                                            : "Tax Invoice"}
                                    </Grid>

                                </Grid>

                                <Grid item xs={1}></Grid>
                            </Grid>
                        )}
                        <Grid item xs={12}></Grid>
                        <Grid item xs={12} container>
                            <Grid item container xs={11} className={clas.BdytitleHedMusa}>
                                <Grid item xs={6} className={clasm.minclr}>
                                    {locInv.invN +
                                        " " +
                                        sta.tot.inv_type_name +
                                        " " +
                                        sta.tot.pay_type_name}
                                </Grid>
                                <Grid item xs={6} className={clasm.minclr}>
                                    {locInv.invNEn +
                                        " " +
                                        sta.tot.inv_type_name_en +
                                        " " +
                                        sta.tot.pay_type_name_en}
                                </Grid>
                            </Grid>
                            <Grid item xs={1}></Grid>
                        </Grid>


                    </Grid>
                    {/* <Grid item xs={2}></Grid> */}
                </Grid>


                <Grid item container style={{ direction: "rtl", paddingTop: "0.5rem" }}>
                    {/* <Grid item xs={1}></Grid> */}
                    <Grid item xs={12}/* className={calssBody.BdymtHeader} */
                    >
                        <Grid item container className={clasm.mincntr}>
                            <Grid item container xs={12}>
                                <Grid item container xs={6}>
                                    <Grid item xs={3} className={clas.BdyborBtRTOP1} style={{ textAlign: "right", paddingRight: 7 }}>
                                        {txtA.invNumr}
                                    </Grid>
                                    <Grid item xs={6} className={clas.BdyborBtRTOP3} >
                                        <Paper className={clasm.minclr}>{sta.tot.id}</Paper>
                                    </Grid>
                                    <Grid item xs={3} className={clas.BdyborBtRTOP2} style={{ textAlign: "left", paddingLeft: 7 }}>
                                        {/* {txtE.invNumr} */}
                                        {"Inv No "}

                                    </Grid>
                                </Grid>
                                <Grid item container xs={6}>
                                    <Grid item xs={3} className={clas.BdyborBtRTOP1} style={{ textAlign: "right", paddingRight: 7 }}>
                                        {"التاريخ"}
                                    </Grid>
                                    <Grid item xs={6} className={clas.BdyborBtRTOP3}>
                                        <Paper className={clasm.minclr}>
                                            {moment(sta.tot.date).format("YYYY/MM/DD")}
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={3} className={clas.BdyborBtRTOP2} style={{ textAlign: "left", paddingLeft: 7 }}>
                                        {"Date"}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item container xs={12}>
                                <Grid item container xs={6}>
                                    <Grid item xs={3} className={clas.BdyborBtR} style={{ textAlign: "right", paddingRight: 7 }}>
                                        {"اسم العميل"}
                                    </Grid>
                                    <Grid item xs={6} className={clasm.minborB}>
                                        <Paper className={clasm.minclr}> {sta.tot.cust_name}</Paper>
                                    </Grid>
                                    <Grid item xs={3} className={clas.BdyborBtL} style={{ textAlign: "left", paddingLeft: 7 }}>
                                        {/* {txtE.invNumr} */}
                                        {"Cust Name"}

                                    </Grid>
                                </Grid>

                                <Grid item container xs={6}>
                                    <Grid item xs={3} className={clas.BdyborBtR} style={{ textAlign: "right", paddingRight: 7 }}>
                                        {"رقم الجوال"}
                                    </Grid>
                                    <Grid item xs={6} className={clasm.minborB}>
                                        <Paper className={clasm.minclr}> {sta.tot.cust_mobile}</Paper>
                                    </Grid>
                                    <Grid item xs={3} className={clas.BdyborBtL} style={{ textAlign: "left", paddingLeft: 7 }}>
                                        {/* {txtE.invNumr} */}
                                        {"Cust No"}

                                    </Grid>
                                </Grid>

                            </Grid>

                            <Grid item container xs={12}>
                                <Grid item container xs={6}>
                                    <Grid item xs={3} className={clas.BdyborBtR} style={{ textAlign: "right", paddingRight: 7 }}>
                                        {"الرقم الضريبي "}
                                    </Grid>
                                    <Grid item xs={6} className={clasm.minborB}>
                                        <Paper className={clasm.minclr}> {sta.tot.tax_no_cust}</Paper>
                                    </Grid>
                                    <Grid item xs={3} className={clas.BdyborBtL} style={{ textAlign: "left", paddingLeft: 7 }}>
                                        {/* {txtE.invNumr} */}
                                        {"Vat No"}

                                    </Grid>
                                </Grid>

                                <Grid item container xs={6}>
                                    <Grid item xs={3} className={clas.BdyborBtR} style={{ textAlign: "right", paddingRight: 7 }}>
                                        {"عنوان العميل"}
                                    </Grid>
                                    <Grid item xs={6} className={clasm.minborB}>
                                        <Paper className={clasm.minclr}> {sta.tot.cust_address}</Paper>
                                    </Grid>
                                    <Grid item xs={3} className={clas.BdyborBtL} style={{ textAlign: "left", paddingLeft: 7 }}>
                                        {/* {txtE.invNumr} */}
                                        {"Cust Address"}

                                    </Grid>
                                </Grid>

                            </Grid>



                            <Grid item container xs={12}>

                                <Grid item container xs={6}>
                                    <Grid item xs={3} className={clas.BdyborBtR} style={{ textAlign: "right", paddingRight: 7 }}>
                                        {locInv?.smallNum == 5 ? "موديل السيارة" : "اسم السيارة"}
                                    </Grid>
                                    <Grid item xs={6} className={clasm.minborB}>
                                        <Paper className={clasm.minclr}> {sta.tot?.CarModel}</Paper>
                                    </Grid>
                                    <Grid item xs={3} className={clas.BdyborBtL} style={{ textAlign: "left", paddingLeft: 7 }}>
                                        {/* {txtE.invNumr} */}
                                        {locInv?.smallNum == 5 ? "Car Model" : "Car Name"}
                                    </Grid>
                                </Grid>

                                <Grid item container xs={6}>
                                    <Grid item xs={3} className={clas.BdyborBtR} style={{ textAlign: "right", paddingRight: 7 }}>
                                        {locInv?.smallNum == 5 ? "سنة الصنع" : "رقم السيارة"}
                                    </Grid>
                                    <Grid item xs={6} className={clasm.minborB}>
                                        <Paper className={clasm.minclr}> {sta.tot?.CarYear}</Paper>
                                    </Grid>
                                    <Grid item xs={3} className={clas.BdyborBtL} style={{ textAlign: "left", paddingLeft: 7 }}>
                                        {/* {txtE.invNumr} */}
                                        {locInv?.smallNum == 5 ? "Made Year" : "Car No"}
                                    </Grid>
                                </Grid>

                            </Grid>

                            <Grid item container xs={12}>
                                <Grid item container xs={6}>
                                    <Grid item xs={3} className={clas.BdyborBtR} style={{ textAlign: "right", paddingRight: 7 }}>
                                        {"رقم اللوحة"}
                                    </Grid>
                                    <Grid item xs={6} className={clasm.minborB}>
                                        <Paper className={clasm.minclr}> {sta.tot?.CarPlatNum}</Paper>
                                    </Grid>
                                    <Grid item xs={3} className={clas.BdyborBtL} style={{ textAlign: "left", paddingLeft: 7 }}>
                                        {/* {txtE.invNumr} */}
                                        {"Plat No"}

                                    </Grid>
                                </Grid>

                                <Grid item container xs={6}>
                                    <Grid item xs={3} className={clas.BdyborBtR} style={{ textAlign: "right", paddingRight: 7 }}>
                                        {locInv?.smallNum== 5 ? "عدد الكيومتر" : "لون السيارة"}
                                    </Grid>
                                    <Grid item xs={6} className={clasm.minborB}>
                                        <Paper className={clasm.minclr}> {sta.tot?.CarColor}</Paper>
                                    </Grid>
                                    <Grid item xs={3} className={clas.BdyborBtL} style={{ textAlign: "left", paddingLeft: 7 }}>
                                        {/* {txtE.invNumr} */}
                                        {locInv?.smallNum == 5 ? "K M No" : "Car Color"}

                                    </Grid>
                                </Grid>
                                {locInv?.smallNum == 5 && (
                                    <Grid item container xs={6}>
                                        <Grid item xs={4} className={clas.BdyborBtR} style={{ textAlign: "right", paddingRight: 7 }}>
                                            {locInv?.smallNum == 5 ? "طراز السيارة" : "اسم السيارة"}
                                        </Grid>
                                        <Grid item xs={4} className={clasm.minborB}>
                                            <Paper className={clasm.minclr}> {sta.tot?.CarType}</Paper>
                                        </Grid>
                                        <Grid item xs={4} className={clas.BdyborBtL} style={{ textAlign: "left", paddingLeft: 7 }}>
                                            {locInv?.smallNum == 5 ? "Car Model" : "Car Name"}
                                        </Grid>
                                    </Grid>

                                )}
                                {locInv?.smallNum == 5 && (
                                    <Grid item container xs={6}>
                                        <Grid item xs={4} className={clas.BdyborBtR} style={{ textAlign: "right", paddingRight: 7 }}>
                                            {locInv?.smallNum == 5 ? "العودة في كيلومتر" : "اسم السيارة"}
                                        </Grid>
                                        <Grid item xs={4} className={clasm.minborB}>
                                            <Paper className={clasm.minclr}> {sta.tot?.CarStructure}</Paper>
                                        </Grid>
                                        <Grid item xs={4} className={clas.BdyborBtL} style={{ textAlign: "left", paddingLeft: 7 }}>
                                            {locInv?.smallNum == 5 ? "Return In KM" : "Car Name"}
                                        </Grid>
                                    </Grid>

                                )}

                            </Grid>


                        </Grid>
                    </Grid>
                    {/* <Grid item xs={1}></Grid> */}
                </Grid>
            </Grid>

        </Grid>
    );
};

export default UnderHeadreCar;
